import React from 'react';

export const FormFieldChecklist = ({ value }) => (
  <div>
    {'checklistItems'} :{' '}
    {value.map((value, index) => (
      <React.Fragment key={index}>
        <div>
          <input
            type="checkbox"
            id={index}
            name={value}
            value={value}
            key={value}
            checked
            disabled
          ></input>
          <label htmlFor={index}> {value}</label>
        </div>
      </React.Fragment>
    ))}
  </div>
);
